// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"322f6b9d","455":"cfdb98ca"}[chunkId] + ".chunk.js";
};